import 'css-chunksrc/client/scenes/projectDetailsConfiguration/form/columns/styles.scss';export default {
  "columns": "_columns_1539v_1",
  "row": "_row_1539v_9",
  "column": "_column_1539v_1",
  "iconBox": "_iconBox_1539v_37",
  "icon": "_icon_1539v_37",
  "columnIcon": "_columnIcon_1539v_55",
  "timeSheetIcon": "_timeSheetIcon_1539v_64",
  "hidden": "_hidden_1539v_69"
};